/* No2moro: retain explicit Shopify Markets subfolder on in-store navigation. */
(() => {
  const marketRoot = window.Shopify?.routes?.root || '/';
  const prefix = marketRoot.replace(/\/$/,'');
  if(!/^\/[a-z]{2}(?:-[a-z]{2})?$/i.test(prefix))return;
  const localePrefix = /^\/[a-z]{2}(?:-[a-z]{2})?(?:\/|$)/i;
  const contentPath = /^\/(?:products|collections|pages|blogs|search)(?:\/|[?#]|$)/i;
  const homePath = /^\/(?:\?.*)?$/;
  const skip = 'a[hreflang], [data-n2m-keep-href], .localization-selector a, .disclosure__list a';
  function fix(anchor) {
    if(!anchor || anchor.matches(skip) || anchor.closest('[data-n2m-market-switcher]'))return;
    const old=anchor.getAttribute('href');
    if(!old || !old.startsWith('/') || old.startsWith('//') ||
       localePrefix.test(old) || (!contentPath.test(old) && !homePath.test(old)))return;
    anchor.setAttribute('href',prefix+(old==='/'?'/':old));
  }
  function scan(root) {
    if(root.nodeType!==1 && root!==document)return;
    if(root.matches?.('a[href]'))fix(root);
    root.querySelectorAll?.('a[href]').forEach(fix);
  }
  let scheduled=false;
  function queue() {
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(()=>{scheduled=false;scan(document);});
  }
  // Delegated click also covers custom JS assigning a new href immediately
  // before navigation; don't rewrite explicit country/locale switches.
  document.addEventListener('click',event=>{
    const a=event.target.closest?.('a[href]');
    if(a)fix(a);
  },true);
  const observer=new MutationObserver(mutations=>{
    for(const m of mutations) {
      if(m.type==='attributes' && m.attributeName==='href') {
        fix(m.target);
      } else if(m.addedNodes?.length) {
        for(const n of m.addedNodes)scan(n);
      }
    }
  });
  function start(){
    scan(document);
    observer.observe(document.documentElement,{subtree:true,childList:true,
      attributes:true,attributeFilter:['href']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
